import { createAction } from "@reduxjs/toolkit";
import { CLEAR_DRAFT, clearDraftType, SET_DRAFT_ROOM, SET_DRAFT_TEXT, SET_DRAFTS, setDraftRoomType, setDraftsType, setDraftTextType } from "./types";

export const setDraftRoom = createAction<setDraftRoomType["payload"]>(SET_DRAFT_ROOM);
export const setDraftText = createAction<setDraftTextType["payload"]>(SET_DRAFT_TEXT);
export const setDrafts = createAction<setDraftsType["payload"]>(SET_DRAFTS);
export const clearDraft = createAction<clearDraftType["payload"]>(CLEAR_DRAFT);
